module.exports = __webpack_public_path__ + "img/svg/google.17b239415acd6476372deda721b0788a.svg";